<form #form="ngForm">
    <app-basic-information-details-card [timeOffPolicy]="timeOffPolicy"></app-basic-information-details-card>
    <app-accrual-schedule-details-card
        #accrualScheduleCard
        [timeOffPolicy]="timeOffPolicy"
    ></app-accrual-schedule-details-card>
    <app-request-rules-details-card
        *ngIf="!timeOffPolicy.isUnlimited"
        [timeOffRequestRule]="timeOffRequestRule"
        [unitOfTime]="unitOfTime"
    ></app-request-rules-details-card>
</form>
